import {
	Button,
	Card,
	CardActions,
	CardContent,
	Grid,
	Theme,
	Typography,
	makeStyles,
} from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors, hexAlpha } from '../../../theme/theme';

const useStyles = makeStyles((theme: Theme) => ({
	card: (props: TermOptionCardProps) => ({
		display: 'flex',
		flexDirection: 'column',
		minWidth: 160,
		minHeight: 180,
		marginRight: theme.spacing(3),
		marginBottom: theme.spacing(3),
		borderRadius: 0,
		backgroundColor: props.isSelected ? theme.palette.primary.light : 'white',
		// color: props.isSelected ? 'white' : 'black',
		color: 'black',
		textAlign: 'center',
		position: 'relative',
		cursor: 'pointer',
	}),
	cardContent: (props: TermOptionCardProps) => ({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		flexGrow: 1,
		border: '2px solid',
		borderBottomWidth: 0,
		borderWidth: 2,
		// borderRadius: 0,
		borderColor: props.isRecommended
			? hexAlpha(theme.palette.primary.main, 0.5)
			: props.isSelected
			? hexAlpha(theme.palette.primary.main, 0)
			: 'white',
	}),
	cardActions: {
		padding: 0,
	},
	ribbon: {
		position: 'absolute',
		top: 0,
		left: 0,
		zIndex: 1,
		overflow: 'hidden',
		width: 75,
		height: 75,
	},
	ribbonInner: {
		fontSize: 11,
		fontWeight: 600,
		color: 'white',
		textAlign: 'center',
		lineHeight: '24px',
		transform: 'rotate(-45deg)',
		width: 100,
		background: theme.palette.secondary.main,
		position: 'absolute',
		top: 10,
		left: -28,
		letterSpacing: 1.3,
	},
	ribbonText: {
		position: 'relative',
		top: 1,
	},
	title: {
		fontSize: 16,
	},
	hr: (props: TermOptionCardProps) => ({
		border: '1px solid',
		margin: '12px 0 16px',
		// borderColor: props.isSelected ? 'white' : colors.grayA20,
		borderColor: colors.grayA20,
	}),
	mainText: {
		fontSize: 26,
		fontWeight: 600,
		letterSpacing: 1.2,
	},

	selectButton: {
		width: '100%',
		borderWidth: 0,
		borderRadius: 0,
		backgroundColor: theme.palette.primary.main,
		color: 'white',
		'&:hover': {
			backgroundColor: hexAlpha(theme.palette.primary.main, 0.8),
		},
	},
}));

interface TermOptionCardProps {
	value: number;
	isRecommended?: boolean;
	isSelected?: boolean;
	setCheckedValue(newValue: number): void;
}

const TermOptionCard: React.FC<TermOptionCardProps> = (props) => {
	const classes = useStyles(props);
	const { t } = useTranslation();
	const { value, isRecommended, isSelected } = props;

	return (
		<Card
			className={classes.card}
			onClick={() => {
				props.setCheckedValue(value);
			}}
		>
			<CardContent className={classes.cardContent}>
				{/* ribbon */}
				{isRecommended && (
					<div className={classes.ribbon}>
						<div className={classes.ribbonInner}>
							<span className={classes.ribbonText}>
								{t('termSelect.popular')}
							</span>
						</div>
					</div>
				)}

				{/* main */}
				<Typography
					className={classes.mainText}
					variant="h5"
					component="h2"
					gutterBottom
				>
					{`${value} ${t('termSelect.months')}`}
				</Typography>
			</CardContent>

			<CardActions disableSpacing className={classes.cardActions}>
				{/* button */}
				<Button className={classes.selectButton}>
					{isSelected ? t('termSelect.selected') : t('termSelect.select')}
				</Button>
			</CardActions>
		</Card>
	);
};

interface TermSelectProps {
	termValues: number[];
	selectedValue?: number;
	recommendedValue?: number;
	setCheckedValue(newValue: number): void;
}

export const TermSelect: React.FC<TermSelectProps> = (props) => (
	<Grid container justifyContent="flex-start">
		{props.termValues.map((val, i) => (
			<TermOptionCard
				key={i}
				value={val}
				isRecommended={val === props.recommendedValue}
				isSelected={val === props.selectedValue}
				setCheckedValue={props.setCheckedValue}
			/>
		))}
	</Grid>
);
